import React from "react";
import { RiMovie2Line } from "react-icons/ri";
import { FiLogIn } from "react-icons/fi";
import { Link } from "react-router-dom";
import Layout from "../../layout/Layout";
import Inputs from "../Inputs";

const Register = () => {
  return (
    <Layout>
      <div className="container mx-auto px-2 my-24 flex-colo">
        <div className="w-1/2 2xl:w-2/5 gap-8 flex-colo p-8 sm:p-14 md:w-3/5 bg-dry rounded-lg border border-border">
          <div className="flex font-bold text-subMain text-6xl" to="/">
            O{" "}
            <span className="flex text-3xl text-white py-4">
              scarsTv
              <RiMovie2Line color="red" />
            </span>
          </div>

          <Inputs
            label="FullName: "
            placeholder="Onyeka Arinze"
            type="text"
            bg={true}
          />

          <Inputs
            label="Email: "
            placeholder="email@gmail.com"
            type="email"
            bg={true}
          />
          <Inputs
            label="Password: "
            placeholder="*********"
            type="password"
            bg={true}
          />
          <Link
            to="/dashboard"
            className="bg-subMain transitions hover:bg-main flex-rows gap-4 text-white p-4 rounded-lg w-full"
          >
            <FiLogIn /> Sign Up
          </Link>
          <p className="text-center text-border">
            Already have an account?{" "}
            <Link to="/login" className="text-text font-semibold ml-2">
              Sign In
            </Link>
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Register;
